module.exports = __webpack_public_path__ + "static/media/clear-night.svg.c8f857c2.png";